import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import H7 from 'UIComponents/elements/headings/H7';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import Big from 'UIComponents/elements/Big';
import UITruncateString from 'UIComponents/text/UITruncateString';
import PartnerTypeIcon from '../../components/icons/PartnerTypeIcon'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message

import MediaQuery from '../../components/layout/MediaQuery'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message

import InputHighlighter from '../../components/storefront/InputHighlighter';
import * as ScreenSizes from '../../constants/layout/ScreenSizes';
import * as ProfileTierLabelKeys from '../../constants/solutions/ProfileTierLabelKey';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getProfileTierLabelI18nKey } from '../../utils/i18n'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message

import { getProfileLevelColorUse } from '../../utils/profiles';
const COMPANY_LOGO_HEIGHT = 75;
const COMPANY_LOGO_WIDTH = 128;
export default function ProfileSearchBarResult({
  description,
  logoUrl,
  name,
  partnerType,
  searchTerm,
  tier
}) {
  const badgeI18nKey = getProfileTierLabelI18nKey(tier, partnerType, ProfileTierLabelKeys.TAG);
  return /*#__PURE__*/_jsx(MediaQuery, {
    minScreenSize: ScreenSizes.SM,
    alternate: /*#__PURE__*/_jsx(UIMediaObject, {
      align: "center",
      itemLeft: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        style: {
          height: COMPANY_LOGO_HEIGHT / 2,
          width: COMPANY_LOGO_WIDTH / 2,
          padding: 4,
          backgroundColor: OLAF
        },
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          style: {
            maxHeight: '100%'
          }
        })
      }),
      spacing: "medium",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex-column justify-center",
        children: /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          children: /*#__PURE__*/_jsx(Big, {
            style: {
              whiteSpace: 'pre-wrap'
            },
            className: "display-block",
            children: /*#__PURE__*/_jsx(H7, {
              style: {
                display: 'inline'
              },
              children: name
            })
          })
        })
      })
    }),
    children: /*#__PURE__*/_jsx(UIMediaObject, {
      align: "center",
      itemLeft: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        style: {
          height: COMPANY_LOGO_HEIGHT,
          width: COMPANY_LOGO_WIDTH,
          padding: 4,
          backgroundColor: OLAF,
          border: `1px solid ${BATTLESHIP}`
        },
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          style: {
            maxHeight: '100%'
          }
        })
      }),
      spacing: "medium",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-column justify-center",
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(Big, {
            className: "display-block",
            children: /*#__PURE__*/_jsx("b", {
              children: name
            })
          }), badgeI18nKey && /*#__PURE__*/_jsx(UIBadge, {
            className: "m-left-2",
            use: getProfileLevelColorUse(partnerType, tier),
            children: /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              children: [/*#__PURE__*/_jsx(PartnerTypeIcon, {
                className: "m-right-1",
                partnerType: partnerType,
                size: 12,
                tier: tier
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: badgeI18nKey
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(UITruncateString, {
            tooltip: false,
            children: /*#__PURE__*/_jsx(InputHighlighter, {
              text: description,
              value: searchTerm
            })
          })
        })]
      })
    })
  });
}